import { ExternalLoginComponent } from './../apps/authentication/external-login/external-login.component';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/layout/layout.service';
import { InboxService } from 'src/app/services/InboxService.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import * as g from 'src/app/globals';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { LoginComponent } from '../apps/authentication/login/login.component';

@Injectable({
  providedIn: 'root',
})
export class NotifyService {
  global = g;
  retryStarting = 15;
  settimeOut: NodeJS.Timeout;
  activitiesCountChanged = new EventEmitter();
  stopTimeOut = new EventEmitter();
  private activitiesCountVal: number;
  get activitiesCount(): number {
    return this.activitiesCountVal;
  }
  set activitiesCount(value: number) {
    if (this.activitiesCountVal !== value) {
      this.activitiesCountChanged.emit(value);
    }

    this.activitiesCountVal = value;
  }

  lastUpdateChanged = new EventEmitter();
  private lastUpdateVal: Date;
  get lastUpdate(): Date {
    return this.lastUpdateVal;
  }
  set lastUpdate(value: Date) {
    if (this.lastUpdateVal !== value) {
      this.lastUpdateChanged.emit(value);
    }
    this.lastUpdateVal = value;
  }

  msgCountChanged = new EventEmitter();
  private msgCountVal = 0;
  get msgCount() {
    return this.msgCountVal;
  }
  set msgCount(value) {
    if (this.msgCountVal !== value) {
      this.msgCountChanged.emit(value);
    }

    this.msgCountVal = value;
  }

  servicesCountChanged = new EventEmitter();
  private servicesCountVal = 0;
  get servicesCount() {
    return this.servicesCountVal;
  }
  set servicesCount(value) {
    if (this.servicesCountVal !== value) {
      this.servicesCountChanged.emit(value);
    }

    this.servicesCountVal = value;
  }

  lastActivityCodeChanged = new EventEmitter();
  private lastActivityCodeVal = 0;
  get lastActivityCode() {
    return this.lastActivityCodeVal;
  }
  set lastActivityCode(value) {
    if (this.lastActivityCodeVal !== value) {
      this.lastActivityCodeChanged.emit(value);
    }

    this.lastActivityCodeVal = value;
  }

  lastMsgCodeChanged = new EventEmitter();
  private lastMsgCodeVal = 0;
  get lastMsgCode() {
    return this.lastMsgCodeVal;
  }
  set lastMsgCode(value) {
    if (this.lastMsgCodeVal !== value) {
      this.lastMsgCodeChanged.emit(value);
    }

    this.lastMsgCodeVal = value;
  }

  lastServiceCodeChanged = new EventEmitter();
  private lastServiceCodeVal = 0;
  get lastServiceCode() {
    return this.lastServiceCodeVal;
  }
  set lastServiceCode(value) {
    if (this.lastServiceCodeVal !== value) {
      this.lastServiceCodeChanged.emit(value);
    }

    this.lastServiceCodeVal = value;
  }

  constructor(
    private http: HttpClient,
    private nzMessageService: NzMessageService,
    private inboxService: InboxService,
    private modalService: NzModalService,
    private layoutService: LayoutService,
    private router: Router
  ) {
    this.stopTimeOut.subscribe(() => {
      clearTimeout(this.settimeOut);
    });
  }

  start() {
    const refreshMs = g.notifications.alertRefreshFrequency || 10000;
    this.settimeOut = setInterval(() => {
      //console.log('startInternal');
      this.startInternal();
    }, refreshMs);
  }

  startInternal() {
    //console.log('Start');
    if (
      this.router.url === '/' ||
      this.router.url.indexOf('apps/authentication') !== -1
    ) {
      // console.log('Start1');
      // this.settimeOut = setTimeout(() => {
      //   this.start();
      // }, 15000);

      // return;
    } else if (!g.applicationInitiated) {
      // console.log('Start2');
      // this.settimeOut = setTimeout(() => {
      //   this.start();
      // }, 15000);

      // return;
    } else if (g.oneTimeToken !== '' && g.userIdentity.Area === 2) {
      // console.log('Start3');
      // return;
    } else if (g.oneTimeToken !== '' && g.userIdentity.Area !== 2) {
      // console.log('Start4');
      // this.settimeOut = setTimeout(() => {
      //   this.start();
      // }, 15000);

      // return;
    } else if (
      g.apiBaseUrl === '' ||
      g.getToken() === '' ||
      g.getToken() === null
    ) {
      // console.log('Start5');
      // this.settimeOut = setTimeout(() => {
      //   this.start();
      // }, 15000);

      // return;
    } else {
      // console.log('Start6');
      if (g.notifications.disableCountEndpoint && g.notifications.disableAlertBell) {
        this.callCount();
      } 

    }
  }

  callCount() {
    this.http
      .get(`${g.apiBaseUrl}authenticate/counts?isTabHidden=${document.hidden}`)
      .pipe(catchError(this.handleError.bind(this)))
      .subscribe(
        (response: {
          isError: boolean;
          invalidSession: boolean;
          result: {
            lastMsgCode: number;
            msgCount: number;
            lastActivityCode: number;
            activitiesCount: number;
            lastServiceCode: number;
            servicesCount: number;
            lastUpdate: number;
          };
        }) => {
          if (response.isError) {
            let modelRef;
            if (this.global.userIdentity.Area == 2) {
              modelRef = this.modalService.create({
                nzTitle: this.layoutService.translate(
                  'Session has expired please login again'
                ),
                nzContent: ExternalLoginComponent,
                nzComponentParams: {
                  hideTitle: true,
                  navigateAfter: false,
                  fromCount: true,
                },
                nzClosable: false,
                nzMaskClosable: false,
                nzWrapClassName: 'partial-login-dialog',
                nzFooter: [],
              });
            } else {
              modelRef = this.modalService.create({
                nzTitle: this.layoutService.translate(
                  'Session has expired please login again'
                ),
                nzContent: LoginComponent,
                nzComponentParams: {
                  hideTitle: true,
                  navigateAfter: false,
                },
                nzClosable: false,
                nzMaskClosable: false,
                nzWrapClassName: 'partial-login-dialog',
                nzFooter: [],
              });
            }

            modelRef.componentInstance.submitCompleted.subscribe((e) => {
              if (e) {
                modelRef.close();
                // setTimeout(() => {
                //   this.start();
                // }, 1000);
              }
            });

            modelRef.afterOpen.subscribe(() => {
              clearInterval(this.settimeOut);
            });

          } else {
            this.retryStarting = 15;
            const d = response.result;
            if (
              d.lastMsgCode !== this.lastMsgCodeVal &&
              this.lastMsgCodeVal !== 0 &&
              this.lastMsgCodeVal !== undefined
            ) {
              this.nzMessageService.info('There is a new Message...');
              this.inboxService.updateUnreadMessagesEmmiter.emit();
              this.setValues(d);
            } else if (
              d.lastActivityCode !== this.lastActivityCode &&
              this.lastActivityCode !== 0 &&
              this.lastActivityCode !== undefined
            ) {
              this.nzMessageService.info('There is a new Activity...');
              this.inboxService.updateUnreadMessagesEmmiter.emit();
              this.setValues(d);
            } else {
              this.setValues(d);
            }

            // setTimeout(() => {
            //   this.start();
            // }, 15000);
          }
        }
      );
  }

  handleError(error: HttpErrorResponse) {
    const currentObject = this;
    if (error.status === 0) {
      let seconds = currentObject.retryStarting;
      const content = this.layoutService.translate(
        'Connection to the backend server has failed, we are going to retry in _VAL_ seconds.'
      );

      let okClicked = false;
      const modelRef = this.modalService.error({
        nzTitle: this.layoutService.translate('Connection Failed'),
        nzContent: `<b>${content.replace('_VAL_', seconds.toString())}</b>`,
        nzClosable: false,
        nzMaskClosable: false,
        nzOkText: this.layoutService.translate('Retry'),
        nzOnOk: () => {
          okClicked = true;
          //this.start();
        },
      });

      const intervalId = setInterval(() => {
        if (!okClicked || seconds === 0) {
          seconds--;
          if (seconds !== 1) {
            modelRef.updateConfig({
              nzContent: `<b>${content.replace(
                '_VAL_',
                seconds.toString()
              )}</b>`,
            });
          }
        } else {
          clearInterval(intervalId);
        }
      }, 1000);

      setTimeout(() => {
        currentObject.retryStarting = currentObject.retryStarting + 15;
        if (currentObject.retryStarting > 60) {
          currentObject.retryStarting = 60;
        }
        if (!okClicked) {
          okClicked = true;
          modelRef.triggerOk();
        }
      }, currentObject.retryStarting * 1000);

      return;
    }

    // setTimeout(() => {
    //   currentObject.start();
    // }, 1000);

    return throwError(error);
  }

  setValues(d) {
    this.activitiesCount = d.ActivitiesCount;
    this.lastUpdate = new Date(d.LastUpdate);
    this.msgCount = d.MsgCount;
    this.servicesCount = d.ServicesCount;
    this.lastActivityCode = d.LastActivityCode;
    this.lastMsgCode = d.lastMsgCode;
    this.lastServiceCode = d.LastServiceCode;
  }
}
